import * as React from 'react';

import UserApi from '../modules/users/api/UserApi';
import {Form, Header, CheckboxProps, Breadcrumb, Button, Grid} from 'semantic-ui-react';
import {RouteComponentProps} from 'react-router';
import Page from './Page';
import User from '../modules/users/domain/aggregates/user/User';
import Registry from '../global/Registry';
import {FormEvent} from 'react';
import {Link} from 'react-router-dom';

interface Props {}

interface State {
	user: User;
	loading: boolean;
}

export default class PreferencesPage extends Page<RouteComponentProps<Props>, State> {

	public constructor (props: RouteComponentProps<Props>) {
		super(props);

		this.state = { user: Registry.getInstance().me, loading: false };
	}

	protected isLoading () {
		return false;
	}

	protected renderTitle () {
		return 'Preferences - Brain Brooder';
	}

	protected renderDescription () {
		return 'Brain Brooder - Preferences.';
	}

	protected renderContent () {
		const sections = [{ key: 'Home', content: <Link to={'/'}>Home</Link> }, { key: 'Preferences', content: 'Preferences', active: true }];

		const preferences = this.state.user.getPreferences();

		return (
			<div className={'lesson'}>
				<Breadcrumb icon='right angle' sections={sections} />

				<Header dividing as='h1' inverted>Preferences</Header>

				<Grid style={{textAlign: 'center'}}>
					<Grid.Row>
						<Grid.Column width={12}>Remind me when I need to review my exercises</Grid.Column>
						<Grid.Column width={2}><Button loading={this.state.loading} compact color={'green'} inverted={preferences.shouldSendReviewReminders() !== true} onClick={() => this.changeCheckbox('REVIEW_REMINDERS', true)}>Yes</Button></Grid.Column>
						<Grid.Column width={2}><Button loading={this.state.loading} compact color={'red'} inverted={preferences.shouldSendReviewReminders() !== false} onClick={() => this.changeCheckbox('REVIEW_REMINDERS', false)}>No</Button></Grid.Column>
					</Grid.Row>
				</Grid>

				{/*<Form inverted style={{textAlign: 'center', marginTop: '48px'}}>*/}
					{/*<Form.Field>*/}
						{/*<Form.Checkbox checked={this.state.user.getPreferences().shouldSendReviewReminders()} onChange={(event: FormEvent<HTMLInputElement>, props: CheckboxProps) => this.changeCheckbox('REVIEW_REMINDERS', props)} label='Send me reminders when I need to review my exercises' />*/}
					{/*</Form.Field>*/}
				{/*</Form>*/}
			</div>
		);
	}

	private async changeCheckbox (type: string, checked: boolean) {
		this.setState({ loading: true });
		this.setState({ user: await UserApi.getInstance().changePreference(type, checked), loading: false });
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/PreferencesPage.tsx